export default __webpack_public_path__ + "static/media/snow_mage.9cfc3efa.png";